const config = {
  CDN: process.env.REACT_APP_CDN,
  env: process.env.REACT_APP_ENV,
  clientKey: process.env.REACT_APP_CLIENT_KEY || 'no-key-provided',
  clientSecret: process.env.REACT_APP_CLIENT_SECRET || 'no-secret-provided',
  enableMessageAnimation:
    process.env.REACT_APP_ENABLE_MESSAGE_ANIMATION || true,
  GOOGLE_MAPS_API_KEY:
    process.env.REACT_APP_GOOGLE_MAPS_KEY || 'no-gmaps-key-provided',
  intercomAppID:
    process.env.REACT_APP_INTERCOM_APP_ID || 'no-intercom-id-provided',
  facebookPixelId: process.env.REACT_APP_FB_PIXEL_ID,
  hugggLifeUrl: process.env.HUGGG_LIFE_URL || 'https://hubs.ly/H0QRKFN0',
  virginBrandId: process.env.REACT_APP_VIRGIN_BRAND_ID,
};

export default config;
